import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { PageAreaContext } from '../PageAreaContext';
import { ParentContext } from '../ParentContext';
import { useDataConditionals } from './useDataConditionals';

export const usePageData = ({ pageItems_shown }) => {

  const parentContexts = useContext(ParentContext)
  const { states } = parentContexts ?? {}
  const { paps_state, eventInfo_state } = states ?? {}
  const { viewKey, view } = paps_state ?? {}

  // eventInfo_state
  const { appDataDocuments } = eventInfo_state ?? {}

  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsShown } = pageArea_state ?? {}

  const _pageItemsShown = pageItems_shown || pageItemsShown

  const { getFilteredData } = useDataConditionals({ dataInit_state: null })
  const [pageData, setPageData] = useState({})

  useEffect(() => {
    if (!_pageItemsShown || !appDataDocuments) return

    const nextPageData = {}

    _.forEach(_pageItemsShown, (pageItemShown, key) => {
      const { dataSource } = pageItemShown ?? {}
      const { dataCollectionName } = dataSource ?? {}

      const _key = dataCollectionName || key

      let data = appDataDocuments[_key]

      if (viewKey && view === key) {
        data = { [viewKey]: data?.[viewKey] }
      }

      const dataState = { viewItem: pageItemShown, uivi: key }

      getFilteredData(data, (res) => {
        nextPageData[key] = {
          data: res,
          count: res ? _.size(res) : 0
        }

        // when all keys processed, set once
        if (_.size(nextPageData) === _.size(_pageItemsShown)) {
          setPageData(nextPageData)
        }
      }, dataState)
    })
  }, [_pageItemsShown, appDataDocuments, viewKey, view])


  return { pageData };

} 